<template>
	<div class="settings--content">
		<settings-section
			title="Migrar dados da caixa"
			sub-title="Migre conversas, mensagens e demais registros relacionados da caixa atual para uma caixa de destino."
		>
			<div v-if="inbox.is_migrating" class="migration-alert medium-9 columns settings-item">
				Esta caixa está em migração no momento. Enquanto a migração estiver em andamento, ela ficará bloqueada.
			</div>

			<label class="medium-9 columns settings-item">
				Caixa de destino
				<select v-model="targetInboxId" :disabled="inbox.is_migrating">
					<option value="">Selecione uma caixa</option>
					<option
						v-for="destinationInbox in destinationInboxes"
						:key="destinationInbox.id"
						:value="String(destinationInbox.id)"
					>
						{{ destinationInbox.name }}
					</option>
				</select>
				<p class="help-text">
					Apenas caixas do mesmo tipo de canal estão disponíveis como destino.
				</p>
			</label>

			<woot-submit-button
				type="submit"
				:disabled="!targetInboxId || uiFlags.isMigrating || inbox.is_migrating"
				button-text="Iniciar migração"
				:loading="uiFlags.isMigrating"
				@click="startMigration"
			/>
		</settings-section>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import SettingsSection from '../../../../../components/SettingsSection';

export default {
	components: {
		SettingsSection,
	},
	mixins: [alertMixin],
	props: {
		inbox: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			targetInboxId: '',
		};
	},
	computed: {
		...mapGetters({
			allInboxes: 'inboxes/getInboxes',
			uiFlags: 'inboxMigrations/getUIFlags',
		}),
		destinationInboxes() {
			return this.allInboxes.filter(
				item =>
					Number(item.id) !== Number(this.inbox.id) &&
					item.channel_type === this.inbox.channel_type
			);
		},
	},
	methods: {
		...mapActions({
			fetchInboxes: 'inboxes/get',
			migrateInbox: 'inboxMigrations/migrateInbox',
		}),
		async startMigration() {
			if (!this.targetInboxId) {
				return;
			}

			try {
				const response = await this.migrateInbox({
					sourceInboxId: this.inbox.id,
					targetInboxId: this.targetInboxId,
				});

				await this.fetchInboxes();

				this.showAlert(response.message || 'Migração iniciada com sucesso.');
			} catch (error) {
				this.showAlert(
					error?.response?.data?.message ||
						error.message ||
						'Não foi possível iniciar a migração.'
				);
			}
		},
	},
	mounted() {
		if (!this.allInboxes.length) {
			this.fetchInboxes();
		}
	},
};
</script>

<style lang="scss" scoped>
.settings-item {
	padding-bottom: var(--space-normal);

	.help-text {
		font-style: normal;
		color: var(--b-500);
		padding-bottom: var(--space-smaller);
	}
}

.migration-alert {
	border: 1px solid var(--y-400);
	background: var(--y-50);
	color: var(--s-900);
	border-radius: var(--border-radius-small);
	padding: var(--space-small);
}
</style>
